import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-aircraft-profile-fields',
  templateUrl: './aircraft-profile-fields.component.html',
  styleUrls: ['./aircraft-profile-fields.component.css'],
})
export class AircraftProfileFields {
  @Input() AircraftType?: string;
  @Input() AircraftModel?: string;
  @Input() AircraftSeries?: string;
  @Input() AircraftManufacturer?: string;
  @Input() MaximumTakeOffWeight?: string;
  @Input() MaximumLandingweight?: string;
  @Input() isMaximumTakeOffWeightAppear?: boolean;
  @Input() isMaximumLandingWeightAppear?: boolean;
}
